import { Component, Input } from '@angular/core';
import { DropdownMenu } from '../../core/models/dropdown-menu';

@Component({
  selector: 'app-dropdown-menu',
  templateUrl: './dropdown-menu.component.html',
  styleUrls: ['./dropdown-menu.component.scss'],
})
export class DropdownMenuComponent {
  @Input() icon = 'pi-cog';
  @Input() title: string;
  @Input() items: DropdownMenu[];
  dropdownPosition = 'right';

  /* ====================================
  *                HELPERS
  ======================================= */

  onHoverButton(event) {
    // this.dropdownPosition =
    //   window.innerWidth - event.x > 160 ? 'left' : 'right';
  }
}
